webpackJsonp([96154644498804],{

/***/ 1824:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/the-best-of-d-ad-festival-2018/"},"frontmatter":{"title":"The Best of D&AD Festival 2018","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 01 article header image 1-c3fa021b0051d155b3cfe3b62bfac17f.jpg"}}},"original":"/img/1160x450 01 article header image 1.jpg"},"category":"Culture"}}}]}},"pathContext":{"tag":"NEW & NOTED"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-new-noted-291a789cd490f1c10d62.js